'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

var _assign = require('lodash/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _linksoftAlbatros = require('linksoft-albatros');

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = {
    isCompact: false,
    processing: false,
    items: [],
    changes: {},
    updating: {},
    addByEan: { ean: '', amount: null },
    id: null,
    totalPriceWithoutVat: 0,
    totalPriceWithVat: 0,
    totalVat: 0,
    dispatchSeparately: false,
    note: null,
    processingOrdersPrice: 0,
    minPriceForDispatch: 0,
    maxAmountPerItem: 0,
    canCreateOrder: false,
    canChangeCart: false,
    dispatchWarning: false,
    offlineMode: false,
    offlineModeMessage: null,
    sendOrderDisabledReason: null,
    showStockAmountSeparately: false,
    notifyMessages: [],
    amountAvailableLimit: 0,
    sortByProp: null,
    sortDirection: 'asc'
};

function numbersOnly(value) {
    if (typeof value !== 'string') value = '';
    return value.replace(/\D/g, '');
}

function getNumber(value) {
    if (typeof value === 'number') return value;
    if (typeof value !== 'string') value = null;
    value = parseInt(value, 10);
    if (isNaN(value)) {
        value = null;
    }
    return value;
}

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var newState = state;
    switch (action.type) {

        case _actionTypes2.default.SORT_ITEMS:
            {
                newState = (0, _extends3.default)({}, state, { sortByProp: action.propName, sortDirection: action.direction });
                break;
            }
        case _actionTypes2.default.ADD_BY_EAN:
            newState = (0, _assign2.default)({}, state, { addByEan: { ean: action.ean, amount: action.amount } });
            break;

        case _actionTypes2.default.UPDATE:
            {
                var remainingChanges = (0, _pickBy2.default)(state.changes, function (i) {
                    return !i.processing;
                });
                var customerSpecific = (0, _merge2.default)({}, state.customerSpecific);
                (0, _values2.default)(state.changes).filter(function (i) {
                    return i.customerId;
                }).forEach(function (i) {
                    var customerChanges = customerSpecific[i.productId];
                    if ((typeof customerChanges === 'undefined' ? 'undefined' : (0, _typeof3.default)(customerChanges)) !== 'object') {
                        customerChanges = {};
                        customerSpecific[i.productId] = customerChanges;
                    }
                    customerChanges[i.customerId] = i.amount;
                });
                newState = (0, _assign2.default)({}, initialState, {
                    changes: remainingChanges,
                    customerSpecific: customerSpecific
                }, action.cart);
                if (Array.isArray(newState.notifyMessages)) {
                    newState.notifyMessages.forEach(function (v) {
                        return _notify2.default.warn(v);
                    });
                }
                break;
            }
        case _actionTypes2.default.CHANGE_AMOUNT:
            {
                newState = (0, _merge2.default)({}, state);
                newState.changedProductId = -1;

                var maxAmount = state.maxAmountPerItem || 0;
                var origAmountInt = action.origAmount || (state.items.find(function (i) {
                    return i.productId === action.productId;
                }) || {}).amount || null;
                var origAmount = origAmountInt === null ? '' : origAmountInt + '';
                var newAmount = numbersOnly(action.amount);
                var newAmountInt = getNumber(newAmount);

                if (newAmountInt <= maxAmount || newAmountInt < origAmountInt) {
                    if (newAmount === origAmount) {
                        delete newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)];
                    } else {
                        newState.changes[(0, _linksoftAlbatros.getCartChangeKey)(action)] = {
                            productId: action.productId,
                            amount: newAmountInt,
                            displayAmount: newAmount,
                            customerId: action.customerId,
                            processing: false
                        };
                    }
                }
                break;
            }
        case _actionTypes2.default.LOAD_DATA:
            newState = (0, _assign2.default)({}, state, { processing: true });
            break;

        case _actionTypes2.default.SUBMIT_CHANGES:
            newState = (0, _merge2.default)({}, state, { processing: true });
            action.items.map(function (i) {
                return (0, _linksoftAlbatros.getCartChangeKey)(i);
            }).forEach(function (k) {
                return (newState.changes[k] || {}).processing = true;
            });
            break;

        case _actionTypes2.default.UPDATE_FAILED:
            newState = (0, _assign2.default)({}, state, { processing: false });
            break;

        // case Types.DISCARD_CHANGES:
        //     newState = merge({}, state);
        //     if (action.productId) {
        //         delete newState.changes[getChangeKey(action)];
        //     } else {
        //         newState.changes = {}; // clean entire shopping cart
        //     }
        //     break;
        case _actionTypes2.default.OPTIONS_CHANGED:
            _abp2.default.log.debug('OPTIONS_CHANGED');
            newState = (0, _assign2.default)({}, state, action.options);
            break;
    }
    return newState;
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/reducer.js
// module id = 911
// module chunks = 0